$(document).ready(function($) { 
  /* SlimMenu Prep */
  $('#navigation').slimmenu({
    resizeWidth: '800',
    collapserTitle: '',
    animSpeed: 0,
    easingEffect: null,
    indentChildren: false,
    childrenIndenter: '&nbsp;',
    expandIcon: '',
    collapseIcon: ''
  });

  //$("a:contains('Alleanza delle Cooperative')").html('<img src="/Portals/1/Images/AlleanzacoopPiemonte_menu.png" style="max-height: 75px"/>');
});

function DownloadFile(filename, url){
  var link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
}

function CreateMap(container, popup, latitude, longitude, zoom) {
  var map = L.map(container).setView([latitude, longitude], zoom);
  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution: '&copy; <a href="https://softwareland.it">Softwareland s.a.s.</a>'
  }).addTo(map);
  L.marker([latitude, longitude]).addTo(map)
    .bindPopup(popup)
    .openPopup();
}